import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { PageLoading } from '@/components/ui/loading';
import { formatDateTime } from '@/lib/utils';
import { Bell, CheckCheck, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function NotificationsPage() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ['notifications'], queryFn: async () => { const r = await api.get<{ data: any[] }>('/notifications'); return r.data ?? []; } });
  const readAllM = useMutation({ mutationFn: () => api.put('/notifications/read-all', {}), onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }) });
  const readM = useMutation({ mutationFn: (id: string) => api.put(`/notifications/${id}/read`, {}), onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }) });
  const deleteM = useMutation({ mutationFn: (id: string) => api.delete(`/notifications/${id}`), onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }) });

  if (isLoading) return <PageLoading />;
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-heading font-bold">Notifications</h1>
        <Button variant="outline" size="sm" onClick={() => readAllM.mutate()}><CheckCheck size={14} className="mr-1" />Mark All Read</Button>
      </div>
      <div className="space-y-2">
        {data?.map((n: any) => (
          <Card key={n.id} className={!n.is_read ? 'border-l-4 border-l-brand-500' : ''}>
            <CardContent className="p-4 flex items-start gap-3">
              <Bell size={18} className={n.is_read ? 'text-muted' : 'text-brand-500'} />
              <div className="flex-1">
                <p className="font-medium text-sm">{n.title}</p>
                <p className="text-sm text-secondary">{n.message}</p>
                <p className="text-xs text-muted mt-1">{formatDateTime(n.created_at)}</p>
              </div>
              <div className="flex gap-1">
                {!n.is_read && <Button variant="ghost" size="icon" onClick={() => readM.mutate(n.id)} title="Mark read"><CheckCheck size={14} /></Button>}
                <Button variant="ghost" size="icon" onClick={() => deleteM.mutate(n.id)} title="Delete"><Trash2 size={14} className="text-red-400" /></Button>
              </div>
            </CardContent>
          </Card>
        ))}
        {(!data || data.length === 0) && <p className="text-center py-12 text-muted">No notifications</p>}
      </div>
    </div>
  );
}
